import React from "react";
import { Grid, Typography } from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";

export const PolicyCounters = ({ policy }) => {
  const { details } = policy;
  const totalCharge_ = details.reduce(
    (acc, detail) => acc + Number(detail.charge || 0),
    0,
  );
  const totalPayment_ = details.reduce(
    (acc, detail) => acc + Number(detail.payment || 0),
    0,
  );

  return (
    <>
      <Grid item xs={12} md={2}>
        <Typography variant="body1" color="info">
          Cargo total: {formatNumber({ input: totalCharge_ }, "$", true)}
        </Typography>
      </Grid>
      <Grid item xs={12} md={2}>
        <Typography variant="body1" color="info">
          Abono total: {formatNumber({ input: totalPayment_ }, "$", true)}
        </Typography>
      </Grid>
      <Grid item xs={12} md={2}>
        <Typography variant="body1" color="info">
          Diferencia:{" "}
          {formatNumber({ input: totalCharge_ - totalPayment_ }, "$", true)}
        </Typography>
      </Grid>
    </>
  );
};
